import { render, staticRenderFns } from "./PUDetails.vue?vue&type=template&id=b7302450&scoped=true"
import script from "./PUDetails.vue?vue&type=script&lang=js"
export * from "./PUDetails.vue?vue&type=script&lang=js"
import style0 from "./PUDetails.vue?vue&type=style&index=0&id=b7302450&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7302450",
  null
  
)

export default component.exports